module.exports = __webpack_public_path__ + "img/client_visit_analyse.92cec9c1.png";